import React, { Component } from "reactn";
import { Snackbar } from "@material-ui/core";

export default class SnackBar extends Component {
    render() {
        const props = this.props;
        return (
            <Snackbar {...props}></Snackbar>
        );
    }
}
